import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Star } from 'lucide-react';

const ProductCard = ({ product }) => {
  return (
    <div className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col h-full">
      {/* Image */}
      <div className="relative overflow-hidden" style={{ height: '220px' }}>
        <img
          src={product.image}
          alt={`${product.name} - ${product.subtitle}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1730102816323-3e60cef43702?w=600&q=60';
          }}
        />
        {/* Badge */}
        <div className="absolute top-3 left-3">
          <span className="bg-orange-500 text-white text-xs font-bold px-2.5 py-1 rounded-full shadow">
            {product.badge}
          </span>
        </div>
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-orange-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-1">
        <div className="mb-3">
          <h3 className="font-black text-xl text-gray-900 group-hover:text-orange-600 transition-colors">
            {product.name}
          </h3>
          <p className="text-orange-500 font-semibold text-sm">{product.subtitle}</p>
        </div>

        <p className="text-gray-600 text-sm leading-relaxed flex-1 mb-4">
          {product.shortDescription}
        </p>

        {/* Features preview */}
        <div className="flex flex-wrap gap-1.5 mb-4">
          {product.features.slice(0, 3).map((feature, i) => (
            <span
              key={i}
              className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full"
            >
              {feature}
            </span>
          ))}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-3 border-t border-gray-100">
          <span className="text-sm font-bold text-gray-800">{product.priceFrom}</span>
          <Link
            to={`/produit/${product.slug}`}
            className="flex items-center gap-1.5 text-orange-500 font-semibold text-sm hover:gap-3 transition-all duration-200 group/btn"
          >
            En savoir plus
            <ArrowRight size={14} className="transition-transform duration-200 group-hover/btn:translate-x-1" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
